'use strict';

var _ = require('lodash');

module.exports = {
  getIcon: function (options) {

    options = _.extend({
      iconSize: [8,8],
      className: 'photo-marker'
    }, options);

    // // needs to ALWAYS have the `base` className
    if (options.className.indexOf('photo-marker') === -1) {
      options.className = options.className && 'photo-marker ' + options.className || 'photo-marker';
    }

    return L.divIcon(options);
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/photos/lib/MarkerUtil.js